export default {
  modalPrefill: {
    type: "crop",
    machine_name: "eta_790a_addendum_a",
    modal_name: "addProfilesModal",
    title: "Crop/Agricultural Activity Profiles",
    formVersionId: 2,
    description:
      "Select the Crop/Agricultural Activity profile(s) to populate in the Addendum A table.",
  },
  name: "Addendum A - Crops and/or Agricultural Activities",
  pageInfo: {
    text: "This Addendum must be fully completed and submitted with the Form ETA-790A when the employer needs to disclose additional information about the payment of wages for specific crops and/or agricultural activities and, if applicable, distinct work task(s) performed within that crop activity or agricultural activity. The employer must disclose wage information covering all the crops or agricultural activities (and, if applicable, distinct work task(s) performed within that crop activity or agricultural activity) that workers will need to perform under the agricultural clearance order. For example, where an employer has multiple applicable hourly rates (e.g., due to work in different States subject to different AEWRs), the employer may disclose the distinct hourly rates by entering the crop and state on the Addendum A. The employer could enter the wage rate information for “Lettuce Harvesting – California” with the hourly AEWR covering work performed in California in one row, and then enter the wage rate information for “Lettuce Harvesting – Arizona” with the hourly AEWR covering work performed in Arizona on another row. <br> Addendum A will collect up to 10 rows of wage offer information for particular crops and/or agricultural activities. For electronic filings, if the employer needs to disclose more than 10 rows of wage offer information, the filing system will automatically provide the employer with the option of adding more rows to the Addendum A until the response is completed. For mailed or paper filings, the employer will make one or more copies of the Addendum A to complete and attach to the Form ETA-790A.",
    coloring: "grey",
    read_more: true,
    character_limit: 1133,
  },
  sections: [
    {
      code: "Addendum A",
      machine_name: "eta_790a_addendum_a",
      name: "Crops and/or Agricultural Activities",
      isModal: true,
      openModalHeader: "Add Addendum A",
      modalHeader: "Add Crop/Agricultural Activity",
      label:
        "Use the table below to enter the details about each crop, when applicable.",
      listType: "table",
      removeFromFieldArray: true,
      modalFields: [
        {
          machine_name: "crop_id",
          label: "Crop ID",
          widget: "text",
          maxLength: 4,
          validate: [],
          tooltip:
            "Enter the “Crop ID” designated, if applicable, for a particular crop or agricultural activity and, if applicable, distinct work task(s) performed within that crop activity or agricultural activity. An employer using large crews working on a wide array of diversified crops may designate one or more “Crop ID” and then use the “Crop ID” to organize wage offer and pay information for multiple varieties of the same crops or commodities on this Addendum A.",
        },
        {
          machine_name: "crop_name",
          label: "Crop or Agricultural Activity",
          widget: "text",
          maxLength: 100,
          validate: ["required"],
          tooltip:
            "Enter the name of the crop or agricultural activity and, if applicable, distinct work task(s) performed within that crop activity or agricultural activity.",
        },
        {
          machine_name: "wage_offer",
          label: "Wage Offer",
          widget: "wage",
          maxLength: 4,
          validate: ["required"],
          tooltip:
            "Enter the wage offer for the crop or agricultural activity.",
        },
        {
          machine_name: "wage_per",
          label: "Per",
          widget: "select",
          selection: ["Hour", "Month", "Piece Rate"],
          validate: ["required"],
          tooltip: "Enter the unit of pay.",
        },
        {
          hideOnTable: true,
          machine_name: "additional_info",
          label:
            "Piece Rate Units / Estimated Hourly Rate / Special Pay Information",
          widget: "text_area",
          rows: 8,
          inputLimit: 500,
          validate: [{ minLength: 5 }],
          tooltip:
            "Enter additional information, such as the piece rate units and estimated hourly wage rate equivalent(s) and/or any other special pay information (e.g., performance bonuses or incentives) associated with performing the job duties or services in the crop or agricultural activity and, if applicable, distinct work task(s) performed within that crop activity or agricultural activity.",
        },
      ],
    },
  ],
};
